<template>
    <div>
        <div v-if="errored">
            <p>{{ $t("message_error") }}</p>
        </div>
        <div class="row pr-3" v-else-if="!errored && featuredStories.length">
            <div class="col-lg-8 pl-0">
                <div id="release_intro">
                <div class="intro">
                  <h2 class="heading_grey h3 text-uppercase">{{ $t("featured_type_name") }}</h2>
                  <h2 class="h1 release_title_mobile">
                    <router-link class="a_no_line" :to="{ name: 'release', params: { lang: topShowcase.language, type: topShowcase.release_type_label, release_id: topShowcase.id, slug: topShowcase.slug } }"><span v-html="topShowcase.content_title"></span></router-link>
                  </h2>
                  <hr id="feature_teal_hr" class="float-left"/>
                  <div class="clearfix"></div>
                  <div class="ontario-lead-statement" v-html="topShowcase.content_lead"></div>
                </div><!-- intro -->

                    <p class="mb-0"><strong>{{ topShowcase.release_date_time_formatted }}</strong></p>
                    <p class="mb-0">
                      <router-link :to="{ name: 'ministry', params: { acronym: topShowcase.ministry_acronym.toLowerCase() } }" >
                        {{ topShowcase.ministry_abbreviated }}
                      </router-link>
                      <span class="heading_grey"></span>

                    </p>

                    </div><!-- release_intro -->
                </div> <!-- col-lg-8 -->

            </div> <!--row -->

            <div class="row mt-4">

            <div class="col-md-4 pl-0 mb-4" v-for="featured_story in featuredStories" v-bind:key="featured_story.id">
                <div class="feature_card pl-3 pr-3 h-100">
                    <p class="heading_grey h6 mt-4 text-uppercase mb-2">{{ $t("featured_type_name") }}</p>
                    <h2 class="release_title_mobile h6">
                      <router-link class="a_no_line" :to="{ name: 'release', params: { lang: featured_story.language, type: featured_story.release_type_label, release_id: featured_story.id, slug: featured_story.slug } }"><span v-html="featured_story.content_title"></span></router-link>
                    </h2>
                    <p class="mb-0"><strong>{{ featured_story.release_date_time_formatted }}</strong></p>
                    <p class="mb-0">
                      <router-link :to="{ name: 'ministry', params: { acronym: featured_story.ministry_acronym.toLowerCase() } }">
                        {{ featured_story.ministry_abbreviated }}
                      </router-link>
                      <span class="heading_grey"> </span>
                    </p>
                </div>
            </div>
        </div>
        <hr class="bold_hr home_hr" v-if="featuredStories.length">
    </div>
</template>

<script>

export default {
  data () {
    return {
      errored: false,
      featuredStories: {},
      topShowcase: {},
      loading: false
    }
  },

  methods: {
    // Get releases
    fetchFeaturedData () {
      this.loading = true
      this.$axios
        .get(process.env.VUE_APP_ROOT_API + 'featured', {
          params: {
            language: this.$root.$i18n.locale
          }
        })
        .then(response => {
          this.topShowcase = response.data.data[0]
          this.featuredStories = response.data.data.slice(1, response.data.data.length)
        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
        .finally(() => (
          this.loading = false
        ))
    }
  },

  mounted () {
    this.fetchFeaturedData()
  }

}

</script>
